import { render, staticRenderFns } from "./preambleBlock.vue?vue&type=template&id=273f12d4&"
import script from "./preambleBlock.vue?vue&type=script&lang=js&"
export * from "./preambleBlock.vue?vue&type=script&lang=js&"
import style0 from "./preambleBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports